import { useEffect } from 'react';
import { isEmulator, isLocalLive } from '../../firebase';

// Shows which data the local app is using. Renders nothing on the deployed site.
const TestModeBanner = () => {
  const label = isEmulator ? 'TEST MODE – fake data' : isLocalLive ? 'LIVE DATA – real customers' : null;

  useEffect(() => {
    if (!label) return;
    const prefix = isEmulator ? '[TEST] ' : '[LIVE] ';
    if (!document.title.startsWith(prefix)) document.title = prefix + document.title;
  }, [label]);

  if (!label) return null;

  return (
    <div
      role="status"
      className={`fixed bottom-3 right-3 z-[9999] pointer-events-none select-none
        px-4 py-1 rounded-full text-white text-xs font-bold tracking-wide shadow-lg
        ${isEmulator ? 'bg-orange-500' : 'bg-red-600'}`}
    >
      {label}
    </div>
  );
};

export default TestModeBanner;
